export default __webpack_public_path__ + "static/media/eatDaBurger.27268f9b.gif";